/* eslint-disable no-underscore-dangle */
import { throwOnError } from './utils';

export const createPartnerClient = (params: Record<string, unknown> = {}) =>
  fetch('/api/partner-clients', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...params }),
  }).then(throwOnError);

export const fetchPartnerClients = (query = '') =>
  fetch(`/api/partner-clients?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError);

export const fetchPartnerClient = (id: string) =>
  fetch(`/api/partner-clients/${id}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError);

export const updatePartnerClient = (id: string, params: Record<string, unknown> = {}) =>
  fetch(`/api/partner-clients/${id}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...params }),
  }).then(throwOnError);
